import axios from 'axios'

// Sanctum SPA session auth against the API's own origin (cross-subdomain:
// voice.typhoonhq.* -> api.typhoonhq.*). withCredentials sends the session
// cookie; withXSRFToken makes axios read the XSRF-TOKEN cookie and send it as
// the X-XSRF-TOKEN header on every mutating request. CORS + shared cookie
// domain on the API side make this work without a same-origin proxy.
const apiOrigin = import.meta.env.VITE_APP_API_BASE_URL

const api = axios.create({
  baseURL: `${apiOrigin}/api`,
  withCredentials: true,
  withXSRFToken: true,
  headers: {
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
})

// The CSRF cookie must be primed before the first login/mutation.
export function fetchCsrfCookie(): Promise<unknown> {
  return axios.get(`${apiOrigin}/sanctum/csrf-cookie`, { withCredentials: true })
}

// Laravel API Resources wrap every response in { data: T }. Callers pass the
// in-flight request and get the unwrapped payload back.
export async function unwrap<T>(request: Promise<{ data: { data: T } }>): Promise<T> {
  const { data } = await request
  return data.data
}

export default api
